import React from "react";
import { Routes, Route, useLocation } from "react-router-dom";
import SignUp from "./view/pages/signup/SignUp";
import Login from "./view/pages/login/Login";
import Home from "./view/pages/home/Home";
import ForgetPassword from "./view/pages/forgetPassword/ForgetPassword";
import ResetPassword from "./view/pages/forgetPassword/ResetPassword";
import DashBoard from "./view/pages/dashBoard/DashBoard";
import Contact from "./view/pages/contact/Contact";
import Plan from "./view/pages/pricing/Plan";
import ProtectedRoutes from "./view/ProtectedRoutes/ProtectedRoutes";
import Footer from "./view/components/footer/Footer";
import ChatbotWidget from "./view/components/chatbot/ChatBot";
import ResumeScore from "./view/pages/resumescrore/ResumeScore";
import About from "./view/pages/about/About";

function App() {
  const location = useLocation();

  const showFooter =
    !location.pathname.startsWith("/dashboard") &&
    location.pathname !== "/login" &&
    location.pathname !== "/signup";

  return (
    <>
      <Routes>
        {/* Public Routes */}
        <Route path="/" element={<Home />} />
        <Route path="/signup" element={<SignUp />} />
        <Route path="/login" element={<Login />} />
        <Route path="/forget-password" element={<ForgetPassword />} />
        <Route path="/reset-password" element={<ResetPassword />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/plan" element={<Plan />} />
        <Route path="/about" element={<About />} />
        <Route path="/resumescorer" element={<ResumeScore />} />


        {/* Private Routes */}
        <Route element={<ProtectedRoutes />}>
          <Route path="/dashboard/*" element={<DashBoard />} />
        </Route>
      </Routes>
      
      <ChatbotWidget />
      
      {showFooter && <Footer />}
    </>
  );
}

export default App;
